module.exports = "<p>Please wait while we redirect you back</p>\r\n"